// Built from Mockup-v2/v2.js for the Shopify theme. Edit the mockup, then rebuild.
var MJA = window.MJA || "";
// MOJOCO v2: product cards, the floating product stage with hotspots, feature lists.
(() => {
  const C = window.MOJOCO;
  if (!C) return;
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const ico = n => `<svg class="ico" aria-hidden="true" viewBox="0 0 24 24"><use href="#${n}"/></svg>`;

  // ---------- Product card ----------
  const card = (k, opts = {}) => {
    const p = C.products[k];
    const price = p.isNew ? 'New' : (p.price == null ? 'Price TBC' : (k === 'washer' ? 'From ' : '') + C.fmt(p.price));
    return `<a class="pcard${opts.feature ? ' is-feature' : ''}" href="${C.url(k)}" data-cat="${p.label}">
      <span class="caps">${p.label}</span>
      ${p.amazonBest ? '<span class="pc-badge">Best seller</span>' : p.isNew ? '<span class="pc-badge">New</span>' : ''}
      <span class="pc-img"><img src="${p.cut}" alt="" loading="lazy"></span>
      <span class="pc-foot"><span><span class="pc-name">${p.name.replace(' 4L', '')}</span><span class="pc-price">${p.isNew ? C.fmt(p.price) : price}</span></span><span class="pc-go">${ico('i-arrow-ur')}</span></span>
    </a>`;
  };
  window.MOJOCO.card = card;

  // ---------- The range (homepage) ----------
  const range = $('[data-range]');
  if (range) {
    const cats = ['All', ...new Set(C.order.map(k => C.products[k].label))];
    const tabs = $('[data-range-tabs]');
    tabs.innerHTML = cats.map((c, i) => `<button type="button" aria-pressed="${i === 0}" data-c="${c}">${c}</button>`).join('');
    const paint = c => { range.innerHTML = C.order.filter(k => c === 'All' || C.products[k].label === c).map(k => card(k, { feature: k === 'dryer' && c === 'All' })).join(''); };
    tabs.addEventListener('click', e => {
      const b = e.target.closest('[data-c]'); if (!b) return;
      $$('button', tabs).forEach(x => x.setAttribute('aria-pressed', String(x === b)));
      paint(b.dataset.c);
    });
    paint('All');
  }

  $$('[data-cards]').forEach(el => { el.innerHTML = el.dataset.cards.split(',').map(k => card(k)).join(''); });

  // ---------- Feature list (icon + title + line) ----------
  $$('[data-flist]').forEach(ul => {
    const p = C.products[ul.dataset.flist];
    ul.innerHTML = p.detail.features.map(f => `<li><span class="fl-ico">${ico(f[0])}</span><span><b>${f[1]}</b><span>${f[2]}</span></span></li>`).join('');
  });
  $$('[data-price]').forEach(el => { const p = C.products[el.dataset.price]; el.textContent = C.priceText(p); });

  // ---------- Floating stage with hotspots ----------
  const buildStage = stage => {
    const k = stage.dataset.stage, p = C.products[k];
    const feats = p.detail.features;
    stage.insertAdjacentHTML('beforeend', `<span class="st-ring" aria-hidden="true"></span><span class="st-shadow" aria-hidden="true"></span>
      <span class="st-obj"><img src="${p.cut}" alt="${p.name}">${p.spots.map((s, i) => `<button class="spot" type="button" style="left:${s[0]}%;top:${s[1]}%" aria-label="${feats[i] ? feats[i][1] : 'Feature'}" aria-pressed="false" data-i="${i}"></button>`).join('')}</span>
      <div class="tip" role="status" aria-live="polite"></div>`);
    const spots = $$('.spot', stage), tip = $('.tip', stage), obj = $('.st-obj', stage);
    let cur = -1, timer = null, touched = false;
    const show = i => {
      cur = i;
      spots.forEach((s, j) => s.setAttribute('aria-pressed', String(j === i)));
      const f = feats[i] || feats[0];
      tip.innerHTML = `${ico(f[0])}<span><b>${f[1]}</b><span>${f[2]}</span></span>`;
      tip.classList.remove('is-on');
      requestAnimationFrame(() => {
        const sr = stage.getBoundingClientRect(), dr = spots[i].getBoundingClientRect(), tr = tip.getBoundingClientRect();
        const cx = dr.left + dr.width / 2 - sr.left, cy = dr.top + dr.height / 2 - sr.top;
        let x = cx < sr.width / 2 ? cx + 22 : cx - 22 - tr.width;
        let y = cy - tr.height / 2;
        x = Math.max(12, Math.min(x, sr.width - tr.width - 12));
        y = Math.max(12, Math.min(y, sr.height - tr.height - 12));
        tip.style.left = x + 'px'; tip.style.top = y + 'px';
        tip.classList.add('is-on');
      });
    };
    const cycle = () => { clearInterval(timer); if (!calm && !touched) timer = setInterval(() => show((cur + 1) % spots.length), 3400); };
    spots.forEach((s, i) => s.addEventListener('click', () => { touched = true; clearInterval(timer); show(i); }));
    const io = 'IntersectionObserver' in window ? new IntersectionObserver(([e]) => { if (e.isIntersecting) { if (cur < 0) show(0); cycle(); } else clearInterval(timer); }, { threshold: .35 }) : null;
    io ? io.observe(stage) : show(0);
    window.addEventListener('resize', () => cur >= 0 && show(cur));
    stage._show = show;
  };
  $$('[data-stage]').forEach(buildStage);
  window.MOJOCO.buildStage = buildStage;

  // ---------- Quiet proof line ----------
  const pl = $('[data-proof-line]');
  if (pl) {
    const R = C.rating;
    pl.innerHTML = `${C.starsHTML(R, 'rating-sm')}<span><b>${R.avg}</b> from ${R.count.toLocaleString()} Amazon ratings</span><span aria-hidden="true">·</span><span><b>50,000+</b> sold</span><span aria-hidden="true">·</span><a href="/pages/reviews">See reviews</a>`;
    $$('.rating svg', pl).forEach(s => s.setAttribute('viewBox', '0 0 24 24'));
  }

  // ---------- Review cards (from reviews-data.js; hidden until it has entries) ----------
  const rc = $('[data-rev-cards]');
  const R = (window.MOJOCO_REVIEWS || []).filter(r => r.stars >= 4 && r.text);
  if (rc && R.length) {
    const star = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m12 2.8 2.8 5.7 6.3.9-4.6 4.4 1.1 6.2L12 17.1 6.4 20l1.1-6.2L2.9 9.4l6.3-.9z"/></svg>';
    const src = r => r.source === 'Amazon' ? 'Verified Amazon purchase' : (r.source || '');
    rc.innerHTML = R.slice(0, 3).map(r => `<figure class="rev-card">
      <span class="rc-stars" aria-label="${r.stars} out of 5 stars">${star.repeat(r.stars)}</span>
      ${r.title ? `<b>${r.title}</b>` : ''}
      <blockquote>${r.text}</blockquote>
      <figcaption>${r.name} · ${C.products[r.product] ? C.products[r.product].short : ''}${src(r) ? `<span>${src(r)}</span>` : ''}</figcaption>
    </figure>`).join('');
  }
})();
